{
	"intelMacTitle": "Intel-based Macs may experience performance and export issues",
	"intelMacMessage": "{{productName}} relies on modern GPU acceleration, which is limited on Intel-based Macs. You may experience slower performance, visual issues while editing, or export problems."
}
